module.exports = __webpack_public_path__ + "img/SautParachute2022.4645bd96.png";